import api from "../../../../../../api";
import React, { useState } from "react";
import values from "../../../../../../values";
import Context from "../../../../../../context";

import * as Yup from "yup";

import { useFormik } from "formik";
import { useQuery } from "react-query";
import {
  ICityItem,
  ICreateAndUpdateMunicipality,
  IProvinceItem,
} from "../../../../../../types/common.interface";
import { ICreateAndUpdateSuperAgent } from "../../../../../../types/superAgent.interface";
import {
  CustomButton2,
  CustomDropdownSearch,
  CustomIcon,
  CustomInput,
  CustomModal,
  CustomView,
} from "../../../../../../components";

import "./index.sass";
import validations from "../../../../../../validations";
import utils from "../../../../../../utils";
import { use } from "i18next";
import { useTranslation } from "react-i18next";

const Create = () => {
  // ** ===========================================================================================================
  // **                                            Value Validation
  // ** -----------------------------------------------------------------------------------------------------------
  const { showModal, setShowModal, createFunction, isLoading } =
    React.useContext(Context.SuperAgentProvinceScreen);
  // const [selectedCity, setSelectedCity] = React.useState<ICityItem>();
  const [selectedProvince, setSelectedProvince] =
    React.useState<IProvinceItem>();
  const [dropDownErrors, setDropDownErrors] = useState<any>({
    province: "",
    // financialGroup: "",
  });
  // const [selectedFinancialGroup, setSelectedFinancialGroup] =
  //   React.useState<any>(undefined);

  // !! ===========================================================================================================
  // !!                                            Start API Call
  // !! -----------------------------------------------------------------------------------------------------------
  const getAllProvince = useQuery([values.useQueryKeys.getAllProvince], () =>
    api.get.common.getAllProvince()
  );
  // const getAllCity = useQuery(
  //   [values.useQueryKeys.getAllCity, selectedProvince],
  //   () => api.get.common.getAllCity({ provinceCode: selectedProvince?.Code })
  // );

  // const getAllFinancilalGroup = useQuery(
  //   [values.useQueryKeys?.getAllFinancialGroup],
  //   () => api.post.administrator.getAllFinancialGroup({})
  // );

  // !! -----------------------------------------------------------------------------------------------------------
  // !!                                             End API Call
  // !! ===========================================================================================================

  const { t } = useTranslation();

  // ?? ===========================================================================================================
  // ??                                           Use Formik Function
  // ?? -----------------------------------------------------------------------------------------------------------

  const formik = useFormik<ICreateAndUpdateMunicipality>({
    enableReinitialize: true,
    initialValues: {
      phoneNumber: "",
      name: "",
    },
    validationSchema: Yup.object({
      // validation
      phoneNumber: validations.yupValidations.phoneNumber,
      name: validations.yupValidations.firstName,
    }),
    onSubmit: (values: ICreateAndUpdateSuperAgent, { setSubmitting }) => {
      const formValues: ICreateAndUpdateSuperAgent = {
        ...values,
        // city: selectedCity,
        province: selectedProvince,
        // financialGroupSchool: selectedFinancialGroup,
      };
      if (
        selectedProvince
        // && selectedCity && selectedFinancialGroup
      ) {
        Promise.resolve(createFunction(formValues))
          .then(() => {
            // setSelectedCity(undefined);
            setSelectedProvince(undefined);
            // setSelectedFinancialGroup(undefined);
            formik.resetForm();
          })
          .catch((e) => setSubmitting(false));
      }
    },
  });

  const submitHandler = () => {
    // validation
    let errors = {};
    if (!selectedProvince) {
      errors = {
        ...errors,
        province: t("province_is_required"),
      };
    }
    // if (!selectedFinancialGroup) {
    //   errors = {
    //     ...errors,
    //     financialGroup: "انتخاب گروه مالی اجباری است",
    //   };
    // }

    setDropDownErrors({
      ...errors,
    });

    formik.submitForm();
  };

  // ?? ===========================================================================================================
  // ??                                               JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------

  return (
    <section id="super-agent-create-modal-container">
      <CustomIcon
        icon="fa-sharp fa-solid fa-circle-plus"
        size="medium"
        hoverTitle={t("createEducation")}
        onClick={() => {
          setShowModal("CREATE");
        }}
      />
      <form onSubmit={submitHandler}>
        <CustomModal
          onClose={() => setShowModal("NONE")}
          open={showModal === "CREATE"}
        >
          <CustomView.Container className="create-form-content">
            <CustomView.Row className="form-row">
              <CustomView.Column medium={6} className="form-colum dropdown">
                <label className="form-label">{t("province")}</label>
                <CustomDropdownSearch
                  items={getAllProvince?.data?.result}
                  itemName="Name"
                  defaultItem={selectedProvince}
                  onSelectItem={(event: IProvinceItem) => {
                    // setSelectedCity(undefined);
                    setSelectedProvince(event);
                    setDropDownErrors({ ...dropDownErrors, province: "" });
                  }}
                  placeHolder={t("selectProvince")}
                  isLoading={getAllProvince.isLoading}
                  isSearch
                />
                <div className="error">
                  {dropDownErrors.province !== "" && dropDownErrors.province}
                </div>
              </CustomView.Column>
              <CustomView.Column medium={6} className="form-colum">
                <CustomInput
                  name="name"
                  id="name"
                  label={t("educationName")}
                  value={formik.values.name}
                  onValueChange={formik.handleChange}
                  formikProps={{ onBlur: formik.handleBlur }}
                  error={formik.errors.name && formik.touched.name}
                  errorText={formik.errors.name}
                />
              </CustomView.Column>
              {/* <CustomView.Column medium={6} className="form-colum dropdown">
                <label className="form-label">شهر</label>
                <CustomDropdownSearch
                  items={getAllCity?.data?.result}
                  itemName="Name"
                  defaultItem={selectedCity}
                  onSelectItem={(event: ICityItem) => {
                    setSelectedCity(event);
                    setDropDownErrors({ ...dropDownErrors, city: "" });
                  }}
                  placeHolder="انتخاب شهر"
                  isLoading={getAllCity.isLoading}
                  isSearch
                />
                <div className="error">
                  {dropDownErrors.city !== "" && dropDownErrors.city}
                </div>
              </CustomView.Column> */}
            </CustomView.Row>
            <CustomView.Row className="form-row">
              <CustomView.Column medium={6} className="form-colum">
                <CustomInput
                  name="phoneNumber"
                  id="phoneNumber"
                  label={t("phoneNumber")}
                  value={utils.convertNumbers2English(
                    formik.values.phoneNumber as string
                  )}
                  onValueChange={formik.handleChange}
                  formikProps={{ onBlur: formik.handleBlur }}
                  error={
                    formik.errors.phoneNumber && formik.touched.phoneNumber
                  }
                  errorText={formik.errors.phoneNumber}
                  maxLength={11}
                />
              </CustomView.Column>
            </CustomView.Row>
            {/* <CustomView.Row className="form-row">
              <CustomView.Column medium={6} className="form-colum dropdown">
                <label className="form-label">گروه مالی</label>
                <CustomDropdownSearch
                  items={getAllFinancilalGroup?.data?.result}
                  itemName="name"
                  defaultItem={selectedFinancialGroup}
                  onSelectItem={(event: any) => {
                    setSelectedFinancialGroup(event);
                    setDropDownErrors({
                      ...dropDownErrors,
                      financialGroup: "",
                    });
                  }}
                  placeHolder="انتخاب گروه مالی"
                />
                <div className="error">
                  {dropDownErrors.financialGroup !== "" &&
                    dropDownErrors.financialGroup}
                </div>
              </CustomView.Column>
            </CustomView.Row> */}
            <CustomView.Row className="form-row buttons-group">
              <CustomView.Column
                large={3}
                medium={4}
                small={6}
                className="form-colum"
              >
                <CustomButton2
                  isLoading={isLoading}
                  onClick={() => setShowModal("NONE")}
                  title={t("cancel")}
                  type="danger"
                />
              </CustomView.Column>
              <CustomView.Column
                large={3}
                medium={4}
                small={6}
                className="form-colum"
              >
                <CustomButton2
                  isLoading={isLoading}
                  onClick={submitHandler}
                  title={t("submit")}
                />
              </CustomView.Column>
            </CustomView.Row>
          </CustomView.Container>
        </CustomModal>
      </form>
    </section>
  );
};

export default Create;
